import styled, { css } from "styled-components";
export const StyledTrialBannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 62px;
  right: 0;
  z-index: 5;
  transition: all ease-in-out 0.3s;
  z-index: 999;

  @media (min-width: 1450px) {
    left: 85px;
  }
  
  .aside-active & {
    left: 230px;
    @media (min-width: 1450px) {
    left: 290px;
    }
  }

  .trial-banner {
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    color: var(--white);
    background: linear-gradient(90deg, #317bff 0%, #874bff 65%, #fdb409 100%);
    max-height: 80px;
    opacity: 1;
    overflow: hidden;
    transition: all 0.350s ease-in-out;

    &.closing {
      max-height: 0;
      opacity: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin: 0;
    }

    .content-holder {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 50px;
    }
  }

  .trial-banner-text {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;

    .trial-banner-upgrade-text {
      font-weight: 300;
    }
  }

  .trial-banner-actions {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .upgrade-btn {
    font-size: 12px;
    line-height: 16px;
    padding: 8px 14px;
  }

  .trial-banner-close-btn {
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const StyledLayout = styled.div`
transition: all 0.350s ease-in-out;
  ${({ $showlayout }) =>
    $showlayout
      ? css`
          padding: 60px 15px 0;

          @media (min-width: 768px) {
            padding: 60px 15px 0;
          }
          @media (min-width: 992px) {
            padding: 50px 0 0 62px;

          }
          @media (min-width: 1450px) {
            padding: 60px 0 0 85px;
            /* transition: all 0.3s ease-in-out; */

  
          }

        
          
          .trial-banner-visible & {
            @media (min-width: 768px) {
              padding: 102px 15px 0;   
            }
            @media (min-width: 992px) {
              padding: 92px 0 0 85px;
              
            }
            @media (min-width: 1450px) {
              padding: 102px 0 0 85px;
              
            }


          }
          .aside-active & {
            padding-left: 230px;

            @media (min-width: 1450px) {
              padding-left: 290px;
            }
          }

          ${({ $nopaddingTop }) =>
          $nopaddingTop &&
          css`
              padding-top: 0 !important;
            `}
        `
      : css`
          padding: 0px;
        `}
  .children {
    width: 100%;
    transition: all 0.350s ease-in-out;
    /* display:${({ $flex }) => ($flex ? "flex" : "")}; */
    ${({ $showlayout }) =>
    $showlayout
      ? css`
              min-height: calc(100dvh - 50px);
              
            @media (min-width: 1450px) {
              min-height: calc(100dvh - 60px);
            }
            
            .automation-builder-page & {
              min-height: 100dvh;
            }
            
            .trial-banner-visible & {
            min-height: calc(100dvh - 92px);
            @media (min-width: 1450px) {
              min-height: calc(100dvh - 110px);
            }

            }
          `
      : css`
            /* background: #fafcff; */
          `}
  }
`;
